import { Controller } from "@hotwired/stimulus"

// Transparent header over the home hero that turns solid once the page scrolls.
//
// <header data-controller="navbar" data-navbar-scrolled-class="is-scrolled">
export default class extends Controller {
  static classes = ["scrolled"]

  connect() {
    this.onScroll = this.update.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  update() {
    this.element.classList.toggle(this.scrolledClass, window.scrollY > 24)
  }
}
